module.exports = __webpack_public_path__ + "img/Perky-Barber-Case-Brief-300x300.8627052b.png";